export default __webpack_public_path__ + "static/media/video_poker.e8751375.webp";